// extracted by mini-css-extract-plugin
export default {"termsWrapper":"common-components-controls-TermsControl-TermsControl__termsWrapper--nlzeg","termsButton":"common-components-controls-TermsControl-TermsControl__termsButton--XMV0W"};